import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styled from 'styled-components';

import CARD_BANNER_COLOURS, { CARD_BANNER_VARIANTS } from '../definitions/CardBannerColours';
import IconGift from '../components/icons/IconGift';


function CardBanner({
    text,
    variant = CARD_BANNER_VARIANTS.giftOffer,
    isCompact = false,
    borderRadius = '4px',
    className,
}) {
    const bannerColours = CARD_BANNER_COLOURS[variant];

    return (
        <Container
            borderRadius={borderRadius}
            className={classNames(className, 'rh-m-0', bannerColours.background, {
                'rh-py-0_25': !isCompact,   // isCompact removes vertical padding around text
            })}
            data-test-name="card-banner"
        >
            <span
                className={classNames(
                    'banner-text rh-display-flex rh-align-items-center rh-justify-content-center rh-text-align-center',
                    'rh-text-xs rh-mx-auto rh-my-0'
                )}
            >
                {/* currently no need to parameterize the icon; but to omit it, leave bannerColours.stroke undefined */}
                <If condition={bannerColours.stroke}>
                    <IconGift
                        className="the-icon rh-display-inline-block rh-icon-xs rh-mr-0_25 rh-flex-shrink-0"
                        outlineWidth="0"
                        stroke={bannerColours.stroke}
                        fill={bannerColours.iconFill}
                    />
                </If>

                <span className={bannerColours.textColour}>
                    {text}
                </span>
            </span>
        </Container>
    );
}

CardBanner.propTypes = {
    text: PropTypes.node.isRequired,
    variant: PropTypes.oneOf(Object.values(CARD_BANNER_VARIANTS)),
    isCompact: PropTypes.bool,
    borderRadius: PropTypes.string,
    className: PropTypes.string,
};


const Container = styled.div`
    border-radius: calc(${props => props.borderRadius} - 1px) calc(${props => props.borderRadius} - 1px) 0 0;
`;

export default CardBanner;
